// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: import.meta.env.VITE_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
// });

// // Request Interceptor: Ensure latest token is used
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor: Handle Expired Tokens
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response && error.response.status === 400) {
//       console.warn("Token expired or invalid. Logging out...");

//       // Clear token and redirect to login
//       localStorage.removeItem("token");
//       window.location.href = "/login"; // Redirect to login page
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

// import axios from "axios";

// const token = localStorage.getItem("token");

// const axiosInstance = axios.create({
//   baseURL: import.meta.env.VITE_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     Authorization: `Bearer ${token}`,
//   },
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");

//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     } else {
//       console.warn("No token found in sessionStorage");
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);

//   }
// );

// export default axiosInstance;

// src/utils/axiosInstance.js
// import axios from "axios";
// import { encryptData,decryptData } from "./encryptionHelper";

// const axiosInstanceMainUrl = axios.create({
//   baseURL: import.meta.env.VITE_MAIN_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
// });

// // Request Interceptor
// axiosInstanceMainUrl.interceptors.request.use(
//   (config) => {
//     // const token = localStorage.getItem("token");
//     // if (token) {
//     //   config.headers["Authorization"] = `Bearer ${token}`;
//     // }
//     // return config;
//      try {
//           const token = localStorage.getItem("token");
//           if (token) {
//             config.headers["Authorization"] = `Bearer ${token}`;
//           }

//           if (config.data && !config._isEncrypted) {
//              console.log("kkkkkkkkkkkk-------------------------------------------------------------------",config.data)
//             const encryptedPayload = encryptData(config.data);
//             if (encryptedPayload.iv || !config.data.iv) {
//               config.data = encryptedPayload;
//             }
//           }
//         } catch (error) {
//           console.error("Request encryption error:", error);
//         }
//         return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Response Interceptor
// axiosInstanceMainUrl.interceptors.response.use(
//   // (response) => response,
//    (response) => {
//       try {
//         if (response.data && response.data.encrypted) {
//           response.data = decryptData(response.data);
//         }
//       } catch (error) {
//         console.error("Response decryption error:", error);
//       }
//       return response;
//     },
//   // (error) => {
//   //   console.log("error: in instace", error);
//   //   const message = error?.response?.data?.messag;
//   //   console.log("message: in instace", message);

//   //   if (
//   //     message === "Invalid Authentication" ||
//   //     error?.response?.status === 401
//   //   ) {
//   //     localStorage.removeItem("token");
//   //     window.location.href = "/login"; // Redirect to login
//   //   }

//   //   return Promise.reject(error);
//   // }
//   (error) => {
//       try {
//         // Decrypt error response if it's encrypted
//         if (
//           error.response &&
//           error.response.data &&
//           error.response.data.encrypted
//         ) {
//           error.response.data = decryptData(error.response.data);
//         }
//       } catch (decryptError) {
//         console.error("Error response decryption failed:", decryptError);
//       }
//       return Promise.reject(error); // still reject so catch() runs
//     }
// );

// export default axiosInstanceMainUrl;

import axios from "axios";
import { toast } from "react-toastify";
import { encryptData, decryptData } from "./encryptionHelper";

const axiosInstanceMainUrl = axios.create({
  baseURL: import.meta.env.VITE_MAIN_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor
// axiosInstanceMainUrl.interceptors.request.use(
//   (config) => {
//     try {
//       const token = localStorage.getItem("token"); // or sessionStorage
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       }
//       //  else {
//       //   console.warn("No token found");
//       // }
//        if (config.data && !config._isEncrypted) {
//         console.log("kkkkkkkkkkkk",config.data)

//               const encryptedPayload = encryptData(config.data);
//               if (encryptedPayload.iv || !config.data.iv) {
//                 config.data = encryptedPayload;
//               }
//             }
//     } catch (error) {
//        console.error("Request encryption error:", error);
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

//----------------------------------------------------
axiosInstanceMainUrl.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // //   Encrypt GET params
  //   if (config.params) {

  //     console.log("------lucky--------",config.params)
  //     config.params = encryptData(config.params);
  //   }

  //  Encrypt POST/PUT body
  if (config.data) {
    config.data = encryptData(config.data);
  }

  return config;
});

// Response Interceptor
// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Handle backend returning unauthorized as string with 200 status
//     if (
//       typeof response.data === "string" &&
//       response.data.toLowerCase().includes("unauthorized")
//     ) {
//       localStorage.removeItem("token");
//       toast.error("Session expired. Please login again.");
//       window.location.href = "/login";
//     }

//     return response;
//   },
//   (error) => {
//     const status = error?.response?.status;
//     const message = error?.response?.data?.message;

//     console.error("Axios error:", error);

//     if (status === 401 || message === "Invalid Authentication") {
//       localStorage.removeItem("token");
//       toast.error("Unauthorized! Please login again.");
//       window.location.href = "/login";
//     }

//     return Promise.reject(error);
//   }
// );
axiosInstanceMainUrl.interceptors.response.use(
  (response) => {
    try {
      // console.log("RAW RESPONSE-------------------------------------:", response.data);
      if (response.data && response.data.encrypted) {
        response.data = decryptData(response.data);
      }
    } catch (error) {
      console.error("Response decryption error:", error);
    }
    return response;
  },
  (error) => {
    try {
      // Decrypt error response if it's encrypted
      if (
        error.response &&
        error.response.data &&
        error.response.data.encrypted
      ) {
        error.response.data = decryptData(error.response.data);
      }
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      console.error("Axios error:", error);

      if (status === 401 || message === "Invalid Authentication") {
        localStorage.removeItem("token");
        toast.error("Unauthorized! Please login again.");
        window.location.href = "/login";
      }
    } catch (decryptError) {
      console.error("Error response decryption failed:", decryptError);
    }

    return Promise.reject(error);
  },
);

export default axiosInstanceMainUrl;
